import { render, staticRenderFns } from "./databases.vue?vue&type=template&id=6e5cba8a&"
import script from "./databases.vue?vue&type=script&lang=js&"
export * from "./databases.vue?vue&type=script&lang=js&"
import style0 from "./databases.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports